/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_home_seo_mt_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turn a simple grid into a clean, aligned GitHub Flavored Markdown table. Set per-column alignment, escape pipes automatically, and copy ready-to-paste Markdown for READMEs, issues, and wikis — entirely in your browser.`)
};

const es_home_seo_mt_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convierte una cuadrícula simple en una tabla Markdown limpia y alineada compatible con GitHub. Configura la alineación por columna, escapa barras automáticamente y copia Markdown listo para pegar en READMEs, problemas y wikis — completamente en tu navegador.`)
};

const de_home_seo_mt_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwandeln Sie ein einfaches Raster in eine saubere, ausgerichtete GitHub Flavored Markdown-Tabelle. Legen Sie die Ausrichtung pro Spalte fest, maskieren Sie Pipes automatisch und kopieren Sie einsatzbereites Markdown für READMEs, Issues und Wikis — alles direkt in Ihrem Browser.`)
};

const nl_home_seo_mt_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transformeer een eenvoudig raster in een schone, uitgelijnde GitHub Flavored Markdown-tabel. Stel per-kolom uitlijning in, ontsnap pijpen automatisch en kopieer kant-en-klare Markdown voor README's, problemen en wiki's — volledig in uw browser.`)
};

const fr_home_seo_mt_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transformez une grille simple en un tableau Markdown saveur GitHub propre et aligné. Définissez l'alignement par colonne, échappez automatiquement les barres verticales et copiez le Markdown prêt à coller pour les README, les problèmes et les wikis — entièrement dans votre navigateur.`)
};

const it_home_seo_mt_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trasforma una griglia semplice in una tabella Markdown con flavour GitHub pulita e allineata. Imposta l'allineamento per colonna, scappa automaticamente le barre verticali e copia il Markdown pronto da incollare per README, problemi e wiki — interamente nel vostro browser.`)
};

const pt_br2_home_seo_mt_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transforme uma grade simples em uma tabela Markdown limpa e alinhada compatível com GitHub. Defina o alinhamento por coluna, escape pipes automaticamente e copie Markdown pronto para colar em READMEs, issues e wikis — totalmente no seu navegador.`)
};

const pt_home_seo_mt_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converta uma grelha simples numa tabela Markdown compatível com GitHub, limpa e alinhada. Defina o alinhamento por coluna, escape pipes automaticamente e copie Markdown pronto para colar para READMEs, questões e wikis — inteiramente no seu navegador.`)
};

const ja_home_seo_mt_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`シンプルなグリッドをきれいで配置された GitHub 風 Markdown テーブルに変換します。列ごとの配置を設定し、パイプを自動的にエスケープし、README、Issue、Wiki 用に貼り付け可能な Markdown をコピーできます — すべてブラウザで。`)
};

const zh_home_seo_mt_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将简单的网格转换为整洁、对齐的 GitHub Flavored Markdown 表格。设置每列对齐方式，自动转义竖线，复制可直接粘贴到 README、issue 和 wiki 的 Markdown——全部在你的浏览器中完成。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const home_seo_mt_p1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.home_seo_mt_p1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("home_seo_mt_p1", locale)
	if (locale === "en") return en_home_seo_mt_p1(inputs)
	if (locale === "es") return es_home_seo_mt_p1(inputs)
	if (locale === "de") return de_home_seo_mt_p1(inputs)
	if (locale === "nl") return nl_home_seo_mt_p1(inputs)
	if (locale === "fr") return fr_home_seo_mt_p1(inputs)
	if (locale === "it") return it_home_seo_mt_p1(inputs)
	if (locale === "pt-BR") return pt_br2_home_seo_mt_p1(inputs)
	if (locale === "pt") return pt_home_seo_mt_p1(inputs)
	if (locale === "ja") return ja_home_seo_mt_p1(inputs)
	return zh_home_seo_mt_p1(inputs)
};